import { Palette } from '@core/config/constants';

/** Configuracion especifica del minijuego de ritmo. Aislada del resto del juego. */
export const RhythmConfig = {
  key: 'RhythmScene',
  title: 'Ritmo Pop',
  description: 'Toca las estrellas al compas antes de que desaparezcan.',
  icon: '🎵',
  color: Palette.primary,

  /** Duracion de la partida en milisegundos. */
  roundDurationMs: 30_000,
  /** Cada cuanto aparece una nueva estrella (ms). */
  spawnIntervalMs: 850,
  /** Tiempo de vida de cada estrella antes de desaparecer (ms). */
  noteLifetimeMs: 1_400,
  /** Radio de la estrella tocable. */
  noteRadius: 60,
  /** Puntos base por acierto. */
  pointsPerHit: 10,
  /** Bonus por mantener combo. */
  comboBonus: 2,
  /** Monedas otorgadas al finalizar por cada 100 puntos. */
  coinsPer100Points: 1,
} as const;
